export enum GptSettingsKeys {
	FrequencyPenalty = 'frequencyPenalty',
	PresencePenalty = 'presencePenalty',
	Temperature = 'temperature',
	RepetitionPenalty = 'repetitionPenalty',
}

export enum GptSettingsRawKeys {
	FrequencyPenalty = 'frequency_penalty',
	PresencePenalty = 'presence_penalty',
	Temperature = 'temperature',
	RepetitionPenalty = 'repetition_penalty',
}
